import BaseService from "../base";
import ApproveChangePPOStepService from "./approveChangePPOStepService";

class ApproveChangePPOService extends BaseService {
  getPrimaryProcedureOwnerStepItem = (
    para: any,
    success: any,
    error: any,
    interfaceList: any,
    mergePayloadMap: any
  ) => {
    ApproveChangePPOStepService.getStepData(para, success, error, interfaceList, mergePayloadMap);
  };

  ChangePrimaryProcedureOwnerTriggerStepAction = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("changePrimaryProcedureOwnerTriggerStepAction", para, success, error);
  };

  CheckPpoIsExisted = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkPpoIsExisted", para, success, error);
  };

  checkPpoLostMembership = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkPpoLostMembership", para, success, error);
  };

  getFlowStepData = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getFlowStepData", para, success, error);
  };
}

const approveChangePPOService = new ApproveChangePPOService();

export default approveChangePPOService;
